import { createRouter, createWebHistory } from 'vue-router'
import statics from './../routes/statics'
import home from './../routes/home'

const routes = []

routes.push(
  ...home,
  ...statics
)

const router = createRouter({
  linkActiveClass: 'active_nav_link',
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
